// src/contracts/ops/emitOps.ts
//
// Canonical emit helpers for Ops events.
// Keeps event names centralized and payloads consistent.
//

import {
  SYNK_WIRING_READY_EVENT,
  SYNK_OPS_METRIC_EVENT,
  SYNK_OPS_VIOLATION_EVENT,
  SYNK_OPS_CAPABILITY_EVENT,
  SYNK_OPS_ACTION_EVENT,
  SYNK_OPS_TIMELINE_EVENT,
} from "./OpsEvents";

export function emitOps(eventName: string, detail: unknown): void {
  try {
    window.dispatchEvent(new CustomEvent(eventName, { detail }));
  } catch {
    // never throw
  }
}

export const emitWiringReady = (detail: unknown) =>
  emitOps(SYNK_WIRING_READY_EVENT, detail);

export const emitOpsMetric = (detail: unknown) =>
  emitOps(SYNK_OPS_METRIC_EVENT, detail);

export const emitOpsViolation = (detail: unknown) =>
  emitOps(SYNK_OPS_VIOLATION_EVENT, detail);

export const emitOpsCapability = (detail: unknown) =>
  emitOps(SYNK_OPS_CAPABILITY_EVENT, detail);

export const emitOpsAction = (detail: unknown) =>
  emitOps(SYNK_OPS_ACTION_EVENT, detail);

export const emitOpsTimeline = (detail: unknown) =>
  emitOps(SYNK_OPS_TIMELINE_EVENT, detail);
